import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business スクリーン分析セクションのレイアウトルート。一覧と詳細の子ルートOutlet
 * @graph-connects none
 */
export const Route = createFileRoute('/screens')({
  component: ScreensLayout,
});

/** @graph-connects none */
function ScreensLayout() {
  return <Outlet />;
}
